// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__Ao-aX","title":"style__title__fxx7D","description":"style__description__yaFog","component":"style__component__VrPmu"};